import React, { Component } from 'react'

export default class TableHeader extends Component {
  render() {
    return (
      <div>
        <div className='table_header_footer'>
          <h3>Sentence</h3>
          {/* <div>Length</div>
          <div>Actions</div> */}
        </div>
      </div>
    );
  }
}
